/**
 * Colors MUI's palette needs as real hex strings — its internal lighten/darken math
 * can't use a CSS var(). Everything else lives as --app-color-* in src/index.css.
 * Must match src/index.css's primitives exactly.
 */
export const COLOR_BRAND_PRIMARY = '#119656';
export const COLOR_BRAND_SECONDARY = '#777777';
export const COLOR_ERROR = '#fb5c5c';
export const COLOR_WARNING = '#dd1f1f';
